import { getQTipData } from '../Tooltip/qTip.utilities';
import type { IconProps } from './Icon.types';

const colorClassesThemeLight = {
  'theme': 'tw:text-sq-theme-dark',
  'white': 'tw:text-sq-white',
  'dark-gray': 'tw:text-sq-fairly-dark-gray',
  'warning': 'tw:text-sq-warning',
  'darkish-gray': 'tw:text-sq-darkish-gray',
  'gray': 'tw:text-sq-disabled-gray',
  'color': '',
  'info': 'tw:text-sq-theme-link',
  'text': 'tw:text-sq-text-color',
  'inherit': '',
  'danger': 'tw:text-sq-danger',
  'theme-light': 'tw:text-sq-theme-light',
  'success': 'tw:text-sq-success',
};

const colorClassesThemeDark = {
  'theme': 'tw:dark:text-sq-theme-dark',
  'white': '',
  'dark-gray': 'tw:text-sq-fairly-dark-gray',
  'warning': '',
  'darkish-gray': 'tw:text-sq-darkish-gray',
  'gray': 'tw:dark:text-sq-fairly-dark-gray',
  'color': '',
  'info': 'tw:dark:text-sq-theme-link',
  'text': 'tw:dark:text-sq-dark-text',
  'inherit': '',
  'danger': 'tw:text-sq-danger',
  'theme-light': 'tw:text-sq-theme-light',
  'success': 'tw:text-sq-success',
};

/**
 * Icon:
 *  - access to Seeq custom icons by providing the desired icon
 *  - leverage "type" to style your icon
 */
const Icon = ({
  onClick,
  icon,
  iconPrefix = undefined,
  type = 'theme',
  extraClassNames,
  id,
  large,
  small,
  size,
  color,
  testId,
  customId,
  number,
  ...tooltipProps
}: IconProps) => {
  if ((type === 'color' && (color === undefined || color === '')) || (color && type !== 'color')) {
    const errorMessage =
      color === undefined || color === ''
        ? 'Icon with type="color" must have prop color specified.'
        : 'Icon with prop color must have type="color".';
    return <div className="tw:text-sq-danger">{errorMessage}</div>;
  }
  const fontAwesomePrefix = iconPrefix ? iconPrefix : 'fa-sharp fa-regular';
  const iconPrefixString = icon.startsWith('fc') ? 'fc' : fontAwesomePrefix;
  const style = type === 'color' && color ? { color } : {};
  const sizeClass = size ? `fa-${size}` : small ? 'fa-sm' : large ? 'fa-lg' : '';
  const appliedClassNames = `${iconPrefixString} ${icon} ${sizeClass} 
  ${colorClassesThemeLight[type]} ${colorClassesThemeDark[type]} ${
    onClick ? 'tw:cursor-pointer' : ''
  } ${extraClassNames} tw:focus:outline-none tw:focus-visible:outline-none tw:outline-none`;

  const tooltipData = getQTipData(tooltipProps);

  return (
    <i
      className={appliedClassNames}
      style={style}
      onClick={onClick}
      data-testid={testId}
      data-customid={customId}
      id={id}
      data-number={number}
      {...tooltipData}
    />
  );
};
export default Icon;
